import { RightInfoStyle } from './InfoStyles';

const RightInfo = () => {
  return (
    <>
      <RightInfoStyle>
        <a href="mailto:ugurtigu@gmail.com" target="_blank">
          ugurtigu@gmail.com
        </a>
      </RightInfoStyle>
    </>
  );
};

export default RightInfo;
